import React, { useState, useEffect } from "react";
import axios from "axios";

import { useSelector, useDispatch } from "react-redux";
import {
  form_load,
  fetch_success3,
  selectPatientelleGrid,
  previous_search,
} from "../../features/patientelle/patientelleSlice";
import CustomTooltip from "./CustomToolTip";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Button, Grid, Form, Checkbox, Icon } from "semantic-ui-react";
import { server } from "../../App";
import { columnDefs, defaultColDef } from "./GridParams/GridParams";
import { useForm } from "react-hook-form";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";
import { selectisAuthenticated } from "../../features/auth/authSlice";

// import Box from "@mui/material/Box";
// import Drawer from "@mui/material/Drawer";
// // import Button from '@mui/material/Button';
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"


function PatientelleGrid(props) {
  // const [state, setState] = React.useState({
  //   left: false,
  // });

  const dispatch = useDispatch();
  const PatientelleState = useSelector(selectPatientelleGrid);
  const { register, handleSubmit } = useForm({ mode: "onChange" });
  const Auth = useSelector(selectisAuthenticated);

  // ag grid state
  const [, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [hideColumn, setHideColumn] = useState(true);

  const [startWith, setStartWith] = useState(false);
  const [contain, setContain] = useState(true);

  const { width, height } = useWindowSize();
  const [NewHeightValue, setNewHeightValue] = useState("80.5vh");

  let navigate = useNavigate();
  let ID = sessionStorage.getItem("ID_Session");
  async function getOneUser() {
    if (ID) {
      await axios
        .get(`${server}users/${ID}`, {
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
        .then((response) => {
          dispatch(fetch_success3(response.data));
          // toast.success("success");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  let searchQuery = {
    cin: PatientelleState?.cinSearch,
    date_naissance: PatientelleState?.date_naissanceSearch,
    nom: PatientelleState?.nomSearch,
    prenom: PatientelleState?.prenomSearch,
    tel: PatientelleState?.telSearch,
  };

  function debounce(cb, delay = 500) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const debounceOnsubmit = debounce((data) => {
    onSubmit(data);
  }, 500);

  // SEARCH FUNCTION
  const onSubmit = async (data) => {
    const { cin, date_naissance, nom, prenom, tel, pathologie_principale } =
      data;
    let mode;
    if (startWith) {
      mode = "startWith";
    } else if (contain) {
      mode = "contain";
    }
    // alphanumerique with space
    const cinRegex = /^[a-zA-Z0-9\s]*$/;
    const telRegex = /^[0-9\s]*$/;
    // alpha with space
    const nomRegex = /^[a-zA-Z\s-'",./]*$/;

    let url;

    if (
      telRegex.test(tel) &&
      tel.length > 2 &&
      cin.length === 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      nom.length === 0
    ) {
      url = `${server}users/SearchByTel/${tel}/${mode}`;
    }

    if (
      cinRegex.test(cin) &&
      // cin.length > 2 &&
      cin.length > 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      nom.length === 0 &&
      tel.length === 0
    ) {
      url = `${server}users/SearchByCin/${cin}/${mode}`;
    }
    if (
      nomRegex.test(pathologie_principale) &&
      // cin.length > 2 &&
      pathologie_principale?.length > 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      nom.length === 0 &&
      tel.length === 0
    ) {
      url = `${server}users/SearchByPathologie_principale/${pathologie_principale}/${mode}`;
    }

    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      nomRegex.test(prenom) &&
      prenom.length > 0 &&
      // prenom.length > 2 &&
      date_naissance?.length > 9 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByNomPrenomDate/${nom}/${prenom}/${date_naissance}/${mode}`;
    }
    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      nomRegex.test(prenom) &&
      // prenom.length > 2 &&
      prenom.length > 0 &&
      date_naissance?.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByNomPrenom/${nom}/${prenom}/${mode}`;
    }

    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      date_naissance?.length > 9 &&
      // prenom.length > 2 &&
      prenom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByNomDate/${nom}/${date_naissance}/${mode}`;
    }

    if (
      nomRegex.test(prenom) &&
      // prenom.length > 2 &&
      prenom.length > 0 &&
      date_naissance?.length > 9 &&
      // nom.length > 2 &&
      nom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByPrenomDate/${prenom}/${date_naissance}/${mode}`;
    }

    if (
      nomRegex.test(prenom) &&
      prenom.length > 0 &&
      // prenom.length > 2 &&
      date_naissance?.length === 0 &&
      nom.length === 0 &&
      // nom.length > 2 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByPrenom/${prenom}/${mode}`;
    }

    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0 &&
      nom !== ""
    ) {
      url = `${server}users/SearchByNom/${nom}/${mode}`;
    }

    if (
      date_naissance?.length > 9 &&
      nom.length === 0 &&
      prenom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByDate/${date_naissance}/${mode}`;
    }
    await axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(fetch_success3(response.data));
        dispatch(previous_search(data));
        // toast.success("success");
      })
      .catch((err) => {
        console.log(err);
        // toast.error("error");
      });
  };

  useEffect(() => {
    getOneUser();
    onSubmit(searchQuery);
    // let timer1 = setTimeout(() => showColumn(), 10000);
    // return () => {
    //   clearTimeout(timer1);
    // };
    // eslint-disable-next-line
  }, []);

  // setTimeout(() => showColumn(), 10000);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    // gridColumnApi.getAllColumns(params.columnApi)
  };

  const showColumn = () => {
    gridColumnApi.setColumnsVisible(
      ["commentaire_sur_patient", "date_de_modification", "date_creation", "user_name"],
      hideColumn
    );

    setHideColumn(!hideColumn);
    // to fit the size of column FIX COLUMN BUG
    // gridApi.sizeColumnsToFit();
  };

  // const forceUpdate = useCallback(() => showColumn, []);

  const initialState = {
    idpatient: "",
    nom: "",
    prenom: "",
    civilite: "",
    nom_mutuelle: "",
    fk_id_liste_mutuelle: "",
    fk_id_civilite: "",
    cin: "",
    date_naissance: "",
    commentaire_sur_patient: "",
    tel: "",
    tel2: "",
    tel3: "",
    fk_id_medecin: "",
    user_name: "",
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(form_load(initialState));
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      var datePartsStart = clientArray.date_naissance.substring(0, 10);
      var dateParts = datePartsStart.split("/");

      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0])
      );
      let fix = moment(cellDate).format("YYYY-MM-DD");

      let pair = { date_naissance: fix };
      let obj = { ...clientArray, ...pair };

      for (const property in obj) {
        if (obj[property] === null) {
          pair = { [property]: "" };
          obj = { ...obj, ...pair };
        }
      }

      dispatch(form_load(obj));
    }
  };

  const onRowDoubleClicked = (e) => {
    e.defaultPrevented = true;
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(form_load(initialState));
    } else {
      // let clientArray = e.api.getSelectedRows()[0];

      // let ConsultationObj = { ID: clientArray.idpatient };
      navigate("/Consultation");
    }
  };

  // const handlePassingData = (event) => {
  //   event.preventDefault();
  //   props.navigate.push({
  //     pathname: "/UpdatePatientelle",
  //     state: PatientelleState,
  //   });
  // };
  // const handleActData = (event) => {
  //   event.preventDefault();
  //   props.navigate.push({
  //     pathname: "/AddToWaitingList",
  //     state: PatientelleState,
  //   });
  // };
  // const handleCreateForm = (event) => {
  //   event.preventDefault();
  //   props.navigate.push({
  //     pathname: "/CreatePatientelle",
  //   });
  // };
  // const handleDeleteForm = (event) => {
  //   event.preventDefault();
  //   props.navigate.push({
  //     pathname: "/DeletePatientelle",
  //     state: PatientelleState,
  //   });
  // };
  // const handleMutuellePassingData = (event) => {
  //   event.preventDefault();
  //   props.navigate.push({
  //     pathname: "/MutuelleAct",
  //     state: PatientelleState,
  //   });
  // };
  // let ConsultationObj = { ...state, rowData: "", ID: state.idpatient }
  // const handleConsultationPassingData = (event) => {
  //   event.preventDefault();
  //   props.navigate.push({
  //     pathname: "/Consultation",
  //     ConsultationObj,
  //   });
  // };

  function name(height, width) {
    if (width >= 7968) {
      setNewHeightValue("62vh");
    } else if (width === 1360) {
      setNewHeightValue("62vh");
    } else {
      setNewHeightValue("80.5vh");
    }
  }
  useEffect(() => {
    name(height, width);
  }, [height, width]);

  function switchSearchcontain(contain) {
    setContain((prev) => !prev);
    if (contain) {
      setStartWith(true);
    } else {
      setStartWith(false);
    }
  }
  function switchSearchstartWith(startWith) {
    setStartWith((prev) => !prev);
    if (startWith) {
      setContain(true);
    } else {
      setContain(false);
    }
  }

  // const logout = async (e) => {
  //   e.preventDefault();
  //   try {
  //     sessionStorage.removeItem("token");
  //     dispatch(user_Not_Authenticated());
  //     navigate("/login");
  //     toast.success("Logout successfully");
  //   } catch (err) {
  //     console.error(err.message);
  //   }
  // };



  let displayLayout = null;

  if (width <= 1200) {
    displayLayout = (
      <Grid.Row className="NonPaddingBotom">
        <Grid.Column>
          <Form onChange={handleSubmit(debounceOnsubmit)} className="fixWidth margintop2vh">
            {/* <Form.Group widths="equal" className="fixForm"> */}
            <div className="field">
              <label>Nom</label>
              <div className="ui input">
                <input
                  autoFocus
                  autoComplete="off"
                  name="nom"
                  maxLength={40}
                  type="text"
                  {...register("nom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Prenom</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="prenom"
                  maxLength={40}
                  type="text"
                  {...register("prenom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>CIN</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="cin"
                  maxLength={20}
                  type="text"
                  {...register("cin")}
                />
              </div>
            </div>
            {/* <React.Fragment key="left">
              <Button icon labelPosition='left' onClick={toggleDrawer("left", true)}>Menu</Button>
              <Drawer
                anchor="left"
                open={state["left"]}
                onClose={toggleDrawer("left", false)}
              >
                {list("left")}
              </Drawer>
            </React.Fragment> */}
            {/* </Form.Group> */}
          </Form>
        </Grid.Column>
        <Grid.Column>
          <Form onChange={handleSubmit(onSubmit)} className="fixWidth margintop2vh">
            {/* <Form.Group widths="equal" className="fixForm"> */}
            <div className=" field">
              <label>Date de naissance</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  type="date"
                  name="date_naissance"
                  min="1900-01-01"
                  max="3018-12-31"
                  {...register("date_naissance")}
                ></input>
              </div>
            </div>
            <div className=" field">
              <label>Pathologie principale</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="pathologie_principale"
                  maxLength={200}
                  type="text"
                  {...register("pathologie_principale")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Tel</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="tel"
                  maxLength={10}
                  type="text"
                  {...register("tel")}
                />
              </div>
            </div>
            {/* <Form.Group grouped> */}

            {width <= 900 ? (
              PatientelleState.nom === undefined ? (
                <Link to="/">
                  <Button icon labelPosition='left' className="IconFixDopdown" color="yellow">
                    <Icon name='angle double right' size='large' />
                    Transférer
                  </Button>
                </Link>
              ) : PatientelleState.nom === "" ? (
                <Link to="/">
                  <Button icon labelPosition='left' className="IconFixDopdown" color="yellow">
                    <Icon name='angle double right' size='large' />
                    Transférer
                  </Button>
                </Link>
              ) : (
                <Link to="/AddToWaitingList">
                  <Button icon labelPosition='left' className="IconFixDopdown" color="yellow">
                    <Icon name='angle double right' size='large' />
                    Transférer
                  </Button>
                </Link>
              )
            ) : null}
            {/* </Form.Group> */}
          </Form>
        </Grid.Column>
      </Grid.Row>
    );
  } else {
    displayLayout = (
      <Grid.Row>
        <Form onChange={handleSubmit(debounceOnsubmit)} className="fixWidth">
          <Form.Group widths="equal" className="fixForm">
            <div className="field">
              <label>Nom</label>
              <div className="ui input">
                <input
                  autoFocus
                  autoComplete="off"
                  name="nom"
                  maxLength={40}
                  type="text"
                  {...register("nom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Prenom</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="prenom"
                  maxLength={40}
                  type="text"
                  {...register("prenom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>CIN</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="cin"
                  maxLength={20}
                  type="text"
                  {...register("cin")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Date de naissance</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  type="date"
                  name="date_naissance"
                  min="1900-01-01"
                  max="3018-12-31"
                  {...register("date_naissance")}
                ></input>
              </div>
            </div>
            <div className=" field">
              <label>Pathologie principale</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="pathologie_principale"
                  maxLength={200}
                  type="text"
                  {...register("pathologie_principale")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Tel</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="tel"
                  maxLength={10}
                  type="text"
                  {...register("tel")}
                />
              </div>
            </div>
            {/* <Form.Group grouped> */}
            {width >= 1280 ?
              <div className=" field">
                <br />
                <Checkbox
                  // width={8}
                  // defaultValue={}
                  // floated="right"
                  className="checkboxFloatedLeftSearch"
                  checked={contain ? true : false}
                  toggle
                  label="Contient expression"
                  // onClick={() => setContain((prev) => !prev)}
                  onClick={() => switchSearchcontain(contain)}
                // className="ToggleCkeckboxclass"
                />
                {/* <br />
            <br /> */}

                <Checkbox
                  className="checkboxFloatedLeftSearch2"
                  // width={8}
                  // defaultValue={}
                  // floated="left"
                  checked={startWith ? true : false}
                  toggle
                  label="Commence par expr"
                  // onClick={() => setStartWith((prev) => !prev)}
                  onClick={() => switchSearchstartWith(startWith)}
                // className="ToggleCkeckboxclass"
                />
                {/* </Form.Group> */}
              </div>

              :
              ""
            }

          </Form.Group>
        </Form>
      </Grid.Row>
    );
  }

  return (
    <div className="viewportheight">
      <h1 className="titrePatient">Patientèle</h1>
      <Grid columns="equal" centered className="fixWidth">
        {/* <Grid.Row> */}
        {/* <Button icon labelPosition='left'.Group vertical={width <= 767 ? true : false}> */}
        {displayLayout}
        {width <= 900 ? null : (
          <Grid.Row className="NonPaddingBotom">
            {/* <Link to="/ActPatientGrid">
              <Button icon labelPosition='left' className="IconFixDopdown" color="brown">
                Aller à la salle d'attente
              </Button>
            </Link> */}
            <Link to="/ActPatientGridHistoric">
              <Button icon labelPosition='left' className="IconFixDopdown" color="black">
                <Icon name='archive' size='large' />
                Historique
              </Button>
            </Link>
            <Link to="/CreatePatientelle">
              <Button icon labelPosition='left' className="IconFixDopdown" color="green">
                <Icon name='add user' size='large' />
                Créer un patient
              </Button>
            </Link>
            {PatientelleState.nom === undefined ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="yellow">
                  <Icon name='angle double right' size='large' />
                  Transférer
                </Button>
              </Link>
            ) : PatientelleState.nom === "" ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="yellow">
                  <Icon name='angle double right' size='large' />
                  Transférer
                </Button>
              </Link>
            ) : (
              <Link to="/AddToWaitingList">
                <Button icon labelPosition='left' className="IconFixDopdown" color="yellow">
                  <Icon name='angle double right' size='large' />
                  Transférer
                </Button>
              </Link>
            )}
            {PatientelleState.nom === undefined ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="blue">
                  <Icon name='edit' size='large' />
                  Modifier
                </Button>
              </Link>
            ) : PatientelleState.nom === "" ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="blue">
                  <Icon name='edit' size='large' />
                  Modifier
                </Button>
              </Link>
            ) : (
              <Link to="/UpdatePatientelle">
                <Button icon labelPosition='left' className="IconFixDopdown" color="blue">
                  <Icon name='edit' size='large' />
                  Modifier
                </Button>
              </Link>
            )}
            {PatientelleState.nom === undefined ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="purple">
                  <Icon name='file alternate' size='large' />
                  Mutuelle
                </Button>
              </Link>
            ) : PatientelleState.nom === "" ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="purple">
                  <Icon name='file alternate' size='large' />
                  Mutuelle
                </Button>
              </Link>
            ) : (
              <Link to="/MutuelleAct">
                <Button icon labelPosition='left' className="IconFixDopdown" color="purple">
                  <Icon name='file alternate' size='large' />
                  Mutuelle
                </Button>
              </Link>
            )}

            {PatientelleState.nom === undefined ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="red">
                  <Icon name='user delete' size='large' />
                  Supprimer
                </Button>
              </Link>
            ) : PatientelleState.nom === "" ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="red">
                  <Icon name='user delete' size='large' />
                  Supprimer
                </Button>
              </Link>
            ) : (
              <Link to="/DeletePatientelle">
                <Button icon labelPosition='left' className="IconFixDopdown" color="red">
                  <Icon name='user delete' size='large' />
                  Supprimer
                </Button>
              </Link>
            )}
            {PatientelleState.nom === undefined ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="orange">
                  <Icon name='dollar sign' size='large' />
                  Paiement
                </Button>
              </Link>
            ) : PatientelleState.nom === "" ? (
              <Link to="/">
                <Button icon labelPosition='left' className="IconFixDopdown" color="orange">
                  <Icon name='dollar sign' size='large' />
                  Paiement
                </Button>
              </Link>
            ) : (
              <Link to="/PaymentActAllActs">
                <Button icon labelPosition='left' className="IconFixDopdown" color="orange">
                  <Icon name='dollar sign' size='large' />
                  Paiement
                </Button>
              </Link>
            )}

            <Link to="/PriseEnCharge">
              <Button icon labelPosition='left' className="IconFixDopdown" color="purple">
                <Icon name='calendar check' size='large' />
                Prise en charge
              </Button>
            </Link>

            {/* <Button icon labelPosition='left' onClick={showColumn} className="littleMarginBottom2">
              <Icon name='expand' size='large' />
              {hideColumn === true ? "Affichage Avancé" : "Afffichage Basic"}
            </Button> */}
            {Auth.role === "admin" ? (
              <Link to="/AnnualRevenu">
                <Button icon labelPosition='left' className="IconFixDopdown" color="olive">
                  <Icon name='line graph' size='large' />
                  Statistiques
                </Button>
              </Link>
            ) : null}
            {Auth.role === "admin" ? (
              <Link to="/bloc_Main">
                <Button icon labelPosition='left' className="IconFixDopdown" color="teal">
                  <Icon name='heartbeat' size='large' />
                  Bloc
                </Button>
              </Link>
            ) : null}
            {Auth.role === "admin" ? (
              <Link to="/Stock">
                <Button icon labelPosition='left' className="IconFixDopdown" color="brown">
                  <Icon name='warehouse' size='large' />
                  Stocks
                </Button>
              </Link>
            ) : null}
          </Grid.Row>
        )}

        {/* </Button.Group> */}
      </Grid>
      <div
        id="myGrid"
        className="ag-theme-alpine"
        style={{
          height: NewHeightValue,
          width: "100%",
        }}
      >
        <AgGridReact
          // reactUi={true}
          rowData={PatientelleState.rowData3}
          animateRows={true}
          sortingOrder={["desc", "asc", null]}
          onGridReady={onGridReady}
          tooltipShowDelay={1500}
          components={{ customTooltip: CustomTooltip }}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection={"single"}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
        ></AgGridReact>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <SpeedDialComponent showColumn={showColumn} hideColumn={hideColumn} />
    </div>
  );
}

export default PatientelleGrid;
